module.exports = __webpack_public_path__ + "assets/img/柱状图.bde6da67.png";